import { render, staticRenderFns } from "./TerminalConfigurationSection.vue?vue&type=template&id=ef904902&scoped=true"
import script from "./TerminalConfigurationSection.vue?vue&type=script&lang=js"
export * from "./TerminalConfigurationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef904902",
  null
  
)

export default component.exports